import { render, staticRenderFns } from "./chatDrawer.vue?vue&type=template&id=4392e5ad&scoped=true&"
import script from "./chatDrawer.vue?vue&type=script&lang=js&"
export * from "./chatDrawer.vue?vue&type=script&lang=js&"
import style0 from "./chatDrawer.vue?vue&type=style&index=0&id=4392e5ad&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4392e5ad",
  null
  
)

export default component.exports